import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
  DragDropContext,
  Draggable,
  Droppable,
  DropResult,
} from 'react-beautiful-dnd';
import {
  BiBox,
  BiDownload,
  BiGridAlt,
  BiImage,
  BiMenu,
  BiRestaurant,
  BiSearch,
  BiX,
} from 'react-icons/bi';
import { FaWhatsapp } from 'react-icons/fa';
import { FaPlus } from 'react-icons/fa';

import { IoMdArrowBack } from 'react-icons/io';
import { AiOutlineDoubleRight } from 'react-icons/ai';
import { useHistory } from 'react-router-dom';
import APIError from '../../errors/APIError';

import Button from '../../newComponents/Button';
import GridGroupAccordion from '../../newComponents/GridGroupAccordion';
import Input from '../../newComponents/Input';
import { ModalHandles } from '../../newComponents/Modal';
import PageHeader from '../../newComponents/PageHeader';
import PizzaGroupAccordion from '../../newComponents/PizzaGroupAccordion';
import Select, { SelectOptionType } from '../../newComponents/Select';
import SimpleGroupAccordion from '../../newComponents/SimpleGroupAccordion';

import GridGroupDrawer from './drawers/GridGroup';
import GridProductDrawer from './drawers/GridProduct';
import PizzaGroupDrawer from './drawers/PizzaGroup';
import PizzaProductDrawer from './drawers/PizzaProduct';
import SimpleGroupDrawer from './drawers/SimpleGroup';
import SimpleProductDrawer from './drawers/SimpleProduct';

import { useAuth } from '../../hooks/auth';
import { useGridGroup } from '../../hooks/gridGroup';
import { useGridProduct } from '../../hooks/gridProduct';
import { usePizzaGroup } from '../../hooks/pizzaGroup';
import { usePizzaProduct } from '../../hooks/pizzaProduct';
import { useSimpleGroup } from '../../hooks/simpleGroup';
import { Image, useSimpleProduct } from '../../hooks/simpleProduct';
import { useToast } from '../../hooks/toast';

import ColorsService from '../../services/ColorsService';
import ComplementItemsService from '../../services/ComplementItemsService';
import ComplementsService from '../../services/ComplementsService';
import GroupsService, { Group, Product } from '../../services/GroupsService';
import ProductsService from '../../services/ProductsService';
import SizesService from '../../services/SizesService';
import UnitsOfMeasurementsService from '../../services/UnitsOfMeasurementService';
import axios from 'axios';

import { IComplement, IComplementItem, IGroup, IProduct } from '../../models';

import { capitalizeFirstLetter } from '../../utils/capitalizeFirstLetter';
import { debounce } from '../../utils/debounce';
import { handleDownloadImage } from '../../utils/handleDownloadImage';

import FileInput from '../../newComponents/FileInput';
import {
  Accordions,
  CloseModalButton,
  Container,
  GroupTypeItem,
  GroupTypeItems,
  Modal,
  ModalFooter,
  ModalHeader,
  PageHeaderActions,
  SortableColumn,
  SortableContainer,
  SortableContent,
  SortableHeader,
  SortableItem,
  Wrapper,
} from './styles';

const Products: React.FC = () => {
  const groupListDiv = useRef<HTMLDivElement>(null);
  const searchProductsRef = useRef<HTMLInputElement>(null);
  const selectGroupModalRef = useRef<ModalHandles>(null);
  const sortModalRef = useRef<ModalHandles>(null);
  const updateImageModalRef = useRef<ModalHandles>(null);
  const [modalReordenIsOpen, setModalReordenarIsOpen] = useState<
    'grupos' | 'produtos' | 'complementos' | 'itens'
  >(() => {
    return 'grupos';
  });

  const history = useHistory();
  const { user, rotinas, findRotinas } = useAuth();
  const { addToast } = useToast();
  const {
    handleChangeGroup: handleChangeSimpleGroup,
    handleOpenDrawer: handleOpenSimpleGroupDrawer,
  } = useSimpleGroup();
  const {
    handleChangeGroup: handleChangePizzaGroup,
    handleOpenDrawer: handleOpenPizzaGroupDrawer,
  } = usePizzaGroup();
  const {
    handleChangeGroup: handleChangeGridGroup,
    handleOpenDrawer: handleOpenGridGroupDrawer,
  } = useGridGroup();
  const {
    groupId: simpleProductGroupId,
    handleChangeGroupsOptions: handleChangeSimpleProductGroupsOptions,
    handleChangeUnitsOfMeasurementOptions: handleChangeSimpleProductUnitsOfMeasurementOptions,
    handleChangeProduct: handleChangeSimpleProduct,
    handleOpenDrawer: handleOpenSimpleProductDrawer,
  } = useSimpleProduct();
  const {
    groupId: pizzaProductGroupId,
    handleChangeGroupsOptions: handleChangePizzaProductGroupsOptions,
    handleChangeUnitsOfMeasurementOptions: handleChangePizzaProductUnitsOfMeasurementOptions,
    handleChangeProduct: handleChangePizzaProduct,
    handleOpenDrawer: handleOpenPizzaProductDrawer,
    handleChangeSelectedGrid,
    handleChangeSelectedNumOfFlavors,
    handleChangeDisplay,
  } = usePizzaProduct();
  const {
    groupId: gridProductGroupId,
    handleChangeGroupsOptions: handleChangeGridProductGroupsOptions,
    handleChangeUnitsOfMeasurementOptions: handleChangeGridProductUnitsOfMeasurementOptions,
    handleChangeProduct: handleChangeGridProduct,
    handleOpenDrawer: handleOpenGridProductDrawer,
  } = useGridProduct();

  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingSort, setIsLoadingSort] = useState(false);
  const [updateProductImage, setUpdateProductImage] = useState<{
    id?: number;
    groupId?: number;
    image?: File | string;
  }>();
  const [
    isLoadingUpdateProductImage,
    setIsLoadingUpdateProductImage,
  ] = useState(false);
  const [groups, setGroups] = useState<Group[]>([]);
  const [groupsToSort, setGroupsToSort] = useState<
    Pick<IGroup, 'id' | 'name' | 'order'>[]
  >([]);
  const [productsToSort, setProductsToSort] = useState<
    Pick<IProduct, 'id' | 'name' | 'order'>[]
  >([]);
  const [complementsToSort, setComplementsToSort] = useState<
    Pick<IComplement, 'id' | 'name' | 'order'>[]
  >([]);
  const [complementItemsToSort, setComplementItemsToSort] = useState<
    Pick<IComplementItem, 'id' | 'name' | 'order'>[]
  >([]);
  const [activeGroup, setActiveGroup] = useState<number>();
  const [activeProduct, setActiveProduct] = useState<number>();
  const [activeComplement, setActiveComplement] = useState<number>();
  const [groupToSearch, setGroupToSearch] = useState(0);
  const [termToSearch, setTermToSearch] = useState('');
  const [isDownloadingLowStock, setIsDownloadingLowStock] = useState(false);
  const [showLowStockOnly, setShowLowStockOnly] = useState(false);
  const [showWhatsappInput, setShowWhatsappInput] = useState(false);
  const [isLoadingWhatsapp, setIsLoadingWhatsapp] = useState(false);
  const whatsappPhoneRef = useRef<HTMLInputElement>(null);

  if (rotinas && !findRotinas('produtos')?.listar) {
    history.push('monitor_pedidos');
  }

  function handleLastProductIndex(): number {
    const groupToSaveProduct = groups.find(
      (group) => group.id === simpleProductGroupId,
    );

    if (groupToSaveProduct?.products && groupToSaveProduct.products?.length) {
      return groupToSaveProduct.products.sort((a, b) => a.order - b.order)[
        groupToSaveProduct.products.length - 1
      ].order;
    }

    return 1;
  }

  function handleLastGroupIndex(): number {
    if (groups.length) {
      return groups.sort((a, b) => a.order - b.order)[groups.length - 1].order;
    }

    return 1;
  }

  function handleFilterGroups(): Group[] {
    let filteredGroups = groups;

    if (groupToSearch) {
      filteredGroups = groups.filter((group) => group.id === groupToSearch);
    }

    if (showLowStockOnly) {
      filteredGroups = filteredGroups.map((filteredGroup) => ({
        ...filteredGroup,
        products: filteredGroup.products?.filter((product) => {
          if (!product.stock) return false;
          const minimumStock = Number(product.stock.minimumStock) || 0;
          const currentStock = Number(product.stock.currentStock) || 0;
          return minimumStock >= currentStock;
        }),
      }));
    }

    if (termToSearch) {
      return filteredGroups.map((filteredGroup) => ({
        ...filteredGroup,
        products: filteredGroup.products?.filter((product) => {
          const searchByName =
            product.name.toLowerCase().indexOf(termToSearch) !== -1;
          let searchByCode = false;
          let searchByGtin = false;

          if (
            !!product.code &&
            product.code.toLowerCase().indexOf(termToSearch) !== -1
          ) {
            searchByCode = true;
          }

          if (
            !!product.gtin &&
            product.gtin.toLowerCase().indexOf(termToSearch) !== -1
          ) {
            searchByGtin = true;
          }

          return searchByName || searchByCode || searchByGtin;
        }),
      }));
    }

    return filteredGroups;
  }

  const countProducts = (): any => {
    const products = groups
      .map((group) => {
        if (group.type === 2) {
          return group.products?.map((product) => product.grids);
        }
        return group.products;
      })
      .flat(2);

    return products.length;
  };

  const handleOnProductSuccessSave = useCallback(
    (groupId: number, storedProduct: Product) => {
      const groupExists = groups.find(
        (foundGroup) => foundGroup.id === groupId,
      );

      if (groupExists) {
        const productExists = (groupExists.products || []).find(
          (foundProduct) => foundProduct.id === storedProduct.id,
        );

        if (productExists) {
          setGroups((oldState) =>
            oldState.map((group) => {
              if (groupExists.id === group.id) {
                return {
                  ...group,
                  products: (group.products || []).map((product) => {
                    if (product.id === storedProduct.id) {
                      return storedProduct;
                    }

                    return product;
                  }),
                };
              }

              return group;
            }),
          );

          return;
        }

        setGroups((oldState) =>
          oldState.map((group) => {
            if (groupExists.id === group.id) {
              return {
                ...group,
                products: [...(group.products || []), storedProduct],
              };
            }

            const productExistsInAnotherGroup = (group.products || []).find(
              (foundProduct) => foundProduct.id === storedProduct.id,
            );

            if (productExistsInAnotherGroup) {
              return {
                ...group,
                products: (group.products || []).filter(
                  (product) => product.id !== storedProduct.id,
                ),
              };
            }

            return group;
          }),
        );
      }
    },
    [groups],
  );

  const handleSelectGroupType = useCallback(
    (type: 1 | 2 | 3) => {
      selectGroupModalRef.current?.close();

      switch (type) {
        case 1: {
          handleOpenSimpleGroupDrawer();
          break;
        }
        case 2: {
          handleOpenGridGroupDrawer();
          break;
        }
        case 3: {
          handleOpenPizzaGroupDrawer();
          break;
        }
        default: {
          break;
        }
      }
    },
    [
      handleOpenSimpleGroupDrawer,
      handleOpenPizzaGroupDrawer,
      handleOpenGridGroupDrawer,
    ],
  );

  const handleLoadGroupsWithProducts = useCallback(async (): Promise<void> => {
    try {
      setIsLoading(true);

      const groupsWithProducts = await GroupsService.listGroups(
        user.empresa_id,
        true,
      );

      setGroups(groupsWithProducts);
    } catch (error) {
      if (error instanceof APIError) {
        addToast({
          title: error.message,
          type: 'error',
        });
      }
    } finally {
      setIsLoading(false);
    }
  }, [user.empresa_id, addToast]);

  const handleActiveGroup = useCallback(
    async (groupId: number) => {
      setActiveGroup(groupId);
      setProductsToSort([]);
      setComplementsToSort([]);
      setComplementItemsToSort([]);

      try {
        const products = await ProductsService.listProducts(
          user.empresa_id,
          groupId,
        );

        if (products.length > 0) {
          setProductsToSort(
            products
              .sort((a, b) => a.order - b.order)
              .map((product) => ({
                id: product.id,
                name: product.name,
                order: product.order,
              })),
          );
        } else {
          addToast({
            title: 'Este grupo não possui produtos.',
            type: 'info',
          });
        }
      } catch (error) {
        if (error instanceof APIError) {
          addToast({
            title: error.message,
            type: 'error',
          });
        }
      }
    },
    [user.empresa_id, addToast],
  );

  const handleActiveProduct = useCallback(
    async (productId: number) => {
      setActiveProduct(productId);
      setComplementsToSort([]);
      setComplementItemsToSort([]);

      try {
        const complements = await ComplementsService.listComplementsByProductId(
          user.empresa_id,
          productId,
        );

        if (complements.length > 0) {
          setComplementsToSort(
            complements
              .sort((a, b) => a.order - b.order)
              .map((complement) => ({
                id: complement.id,
                name: complement.name,
                order: complement.order,
              })),
          );
        } else {
          addToast({
            title: 'Este produto não possui complementos.',
            type: 'info',
          });
        }
      } catch (error) {
        if (error instanceof APIError) {
          addToast({
            title: error.message,
            type: 'error',
          });
        }
      }
    },
    [user.empresa_id, addToast],
  );

  const handleActiveComplement = useCallback(
    async (complementId: number) => {
      setActiveComplement(complementId);
      setComplementItemsToSort([]);

      try {
        const complementItems = await ComplementItemsService.listComplementItems(
          user.empresa_id,
          complementId,
        );

        if (complementItems.length > 0) {
          setComplementItemsToSort(
            complementItems
              .sort((a, b) => a.order - b.order)
              .map((complementItem) => ({
                id: complementItem.id,
                name: complementItem.name,
                order: complementItem.order,
              })),
          );
        } else {
          addToast({
            title: 'Este complemento não possui itens-complementos.',
            type: 'info',
          });
        }
      } catch (error) {
        if (error instanceof APIError) {
          addToast({
            title: error.message,
            type: 'error',
          });
        }
      }
    },
    [user.empresa_id, addToast],
  );

  const handleOnGroupSuccessSave = useCallback(
    (storedGroup: Group) => {
      const groupExists = groups.find(
        (foundGroup) => foundGroup.id === storedGroup.id,
      );

      if (groupExists) {
        setGroups((oldState) =>
          oldState.map((group) => {
            if (groupExists.id === group.id) {
              return {
                ...storedGroup,
                products: group.products,
              };
            }

            return group;
          }),
        );

        return;
      }

      setGroups((oldState) => [...oldState, { ...storedGroup, products: [] }]);
      groupListDiv.current?.scrollIntoView({
        block: 'end',
        behavior: 'smooth',
      });
    },
    [groups],
  );

  const handleEditSimpleGroup = useCallback(
    async (groupId: number) => {
      addToast({
        title: 'Obtendo as informações do grupo',
        type: 'info',
      });

      try {
        const group = await GroupsService.showGroup(user.empresa_id, groupId);

        const { id, name, image } = group;

        handleChangeSimpleGroup({ id, name, image });
        handleOpenSimpleGroupDrawer();
      } catch (error) {
        if (error instanceof APIError) {
          addToast({
            title: error.message,
            type: 'error',
          });

          return;
        }

        addToast({
          title: 'Ocorreu um erro durante a operação',
          type: 'error',
        });
      }
    },
    [
      user.empresa_id,
      addToast,
      handleChangeSimpleGroup,
      handleOpenSimpleGroupDrawer,
    ],
  );

  const handleEditPizzaGroup = useCallback(
    async (groupId: number) => {
      addToast({
        title: 'Obtendo as informações do grupo',
        type: 'info',
      });

      try {
        const group = await GroupsService.showGroup(user.empresa_id, groupId);

        const { id, name, image, complements } = group;

        handleChangePizzaGroup({
          id,
          name,
          image,
          complements: (complements || []).map((complement) => ({
            id: Number(complement.id),
            order: Number(complement.order),
            name: complement.name,
            maximumQuantity: Number(complement.maximumQuantity),
            minimumQuantity: Number(complement.minimumQuantity),
            isRequired: complement.isRequired,
            type: Number(complement.type),
            items: complement.items.map((item) => ({
              id: Number(item.id),
              order: Number(item.order),
              name: item.name,
              maximumQuantity: Number(item.maximumQuantity),
              minimumQuantity: Number(item.minimumQuantity),
              rawMaterialId: Number(item.rawMaterialId),
              code: item.code,
              image: item.image,
              price: Number(item.price.value),
              checked: Boolean(item.checked),
            })),
          })),
        });
        handleOpenPizzaGroupDrawer();
      } catch (error) {
        if (error instanceof APIError) {
          addToast({
            title: error.message,
            type: 'error',
          });

          return;
        }

        addToast({
          title: 'Ocorreu um erro durante a operação',
          type: 'error',
        });
      }
    },
    [
      user.empresa_id,
      addToast,
      handleChangePizzaGroup,
      handleOpenPizzaGroupDrawer,
    ],
  );

  const handleEditGridGroup = useCallback(
    async (groupId: number) => {
      addToast({
        title: 'Obtendo as informações do grupo',
        type: 'info',
      });

      try {
        const group = await GroupsService.showGroup(user.empresa_id, groupId);

        const { id, name, image, complements } = group;

        handleChangeGridGroup({
          id,
          name,
          image,
          complements: (complements || []).map((complement) => ({
            id: Number(complement.id),
            order: Number(complement.order),
            name: complement.name,
            maximumQuantity: Number(complement.maximumQuantity),
            minimumQuantity: Number(complement.minimumQuantity),
            isRequired: complement.isRequired,
            type: Number(complement.type),
            items: complement.items.map((item) => ({
              id: Number(item.id),
              order: Number(item.order),
              name: item.name,
              maximumQuantity: Number(item.maximumQuantity),
              minimumQuantity: Number(item.minimumQuantity),
              rawMaterialId: Number(item.rawMaterialId),
              code: item.code,
              image: item.image,
              price: Number(item.price.value),
              checked: Boolean(item.checked),
            })),
          })),
        });
        handleOpenGridGroupDrawer();
      } catch (error) {
        if (error instanceof APIError) {
          addToast({
            title: error.message,
            type: 'error',
          });

          return;
        }

        addToast({
          title: 'Ocorreu um erro durante a operação',
          type: 'error',
        });
      }
    },
    [
      user.empresa_id,
      addToast,
      handleChangeGridGroup,
      handleOpenGridGroupDrawer,
    ],
  );

  const handleDeleteGroup = useCallback(
    async (groupId: number) => {
      const groupToDelete = groups.find((group) => group.id === groupId);

      if (!groupToDelete) {
        addToast({
          title: 'Ocorreu um erro durante a operação',
          type: 'error',
        });

        return;
      }

      try {
        setGroups((oldState) =>
          oldState.filter((group) => group.id !== groupId),
        );

        await GroupsService.deleteGroup(user.empresa_id, groupId);

        addToast({
          title: 'Grupo excluído com sucesso!',
          type: 'success',
        });
      } catch (error) {
        setGroups((oldState) =>
          [...oldState, groupToDelete].sort((a, b) => a?.order - b?.order),
        );

        if (error instanceof APIError) {
          addToast({
            title: error.message,
            type: 'error',
          });

          return;
        }

        addToast({
          title: 'Ocorreu um erro durante a operação',
          type: 'error',
        });
      }
    },
    [groups, user.empresa_id, addToast],
  );

  const handleSortProducts = useCallback(
    (groupId: number, products?: Product[]) => {
      setGroups((oldState) =>
        oldState.map((group) => {
          if (group.id === groupId) {
            return {
              ...group,
              products,
            };
          }

          return group;
        }),
      );
    },
    [],
  );

  const handleOnGroupsDragEnd = useCallback(
    (dropResult: DropResult) => {
      const { destination, source } = dropResult;

      if (
        typeof destination?.index === 'number' &&
        source.index !== destination.index
      ) {
        let sortedGroups = Array.from(groupsToSort);
        const [removedGroup] = sortedGroups.splice(source.index, 1);

        sortedGroups.splice(destination.index, 0, removedGroup);

        sortedGroups = sortedGroups.map((group, groupIndex) => ({
          ...group,
          order: groupIndex + 1,
        }));

        setGroupsToSort(sortedGroups);
      }
    },
    [groupsToSort],
  );

  const handleOnProductsDragEnd = useCallback(
    (dropResult: DropResult) => {
      const { destination, source } = dropResult;

      if (
        typeof destination?.index === 'number' &&
        source.index !== destination.index
      ) {
        let sortedProducts = Array.from(productsToSort);
        const [removedProduct] = sortedProducts.splice(source.index, 1);

        sortedProducts.splice(destination.index, 0, removedProduct);

        sortedProducts = sortedProducts.map((product, productIndex) => ({
          ...product,
          order: productIndex + 1,
        }));

        setProductsToSort(sortedProducts);
      }
    },
    [productsToSort],
  );

  const handleOnComplementsDragEnd = useCallback(
    (dropResult: DropResult) => {
      const { destination, source } = dropResult;

      if (
        typeof destination?.index === 'number' &&
        source.index !== destination.index
      ) {
        let sortedComplements = Array.from(complementsToSort);
        const [removedComplement] = sortedComplements.splice(source.index, 1);

        sortedComplements.splice(destination.index, 0, removedComplement);

        sortedComplements = sortedComplements.map(
          (complement, complementIndex) => ({
            ...complement,
            order: complementIndex + 1,
          }),
        );

        setComplementsToSort(sortedComplements);
      }
    },
    [complementsToSort],
  );

  const handleOnComplementItemsDragEnd = useCallback(
    (dropResult: DropResult) => {
      const { destination, source } = dropResult;

      if (
        typeof destination?.index === 'number' &&
        source.index !== destination.index
      ) {
        let sortedComplementItems = Array.from(complementItemsToSort);
        const [removedComplementItem] = sortedComplementItems.splice(
          source.index,
          1,
        );

        sortedComplementItems.splice(
          destination.index,
          0,
          removedComplementItem,
        );

        sortedComplementItems = sortedComplementItems.map(
          (complementItem, complementItemIndex) => ({
            ...complementItem,
            order: complementItemIndex + 1,
          }),
        );

        setComplementItemsToSort(sortedComplementItems);
      }
    },
    [complementItemsToSort],
  );

  const handleChangeGroupStatus = useCallback(
    async (groupId: number, status: boolean) => {
      const groupToUpdate = groups.find((group) => group.id === groupId);

      if (!groupToUpdate) {
        addToast({
          title: 'Ocorreu um erro durante a operação',
          type: 'error',
        });

        return;
      }

      try {
        setGroups((oldState) =>
          oldState.map((group) => {
            if (group.id === groupId) {
              return {
                ...group,
                pauseSale: status,
              };
            }

            return group;
          }),
        );

        await GroupsService.editGroupStatus(user.empresa_id, groupId, status);
      } catch (error) {
        setGroups((oldState) =>
          oldState.map((group) => {
            if (group.id === groupId) {
              return groupToUpdate;
            }

            return group;
          }),
        );

        if (error instanceof APIError) {
          addToast({
            title: error.message,
            type: 'error',
          });

          return;
        }

        addToast({
          title: 'Ocorreu um erro durante a operação',
          type: 'error',
        });
      }
    },
    [groups, user.empresa_id, addToast],
  );

  const handleChangeProductStatus = useCallback(
    async (groupId: number, productId: number, status: boolean) => {
      const groupProduct = groups.find((group) => group.id === groupId);

      if (!groupProduct) {
        addToast({
          title: 'Ocorreu um erro durante a operação',
          type: 'error',
        });

        return;
      }

      const productToUpdate = (groupProduct?.products || []).find(
        (product) => product.id === productId,
      );

      if (!productToUpdate) {
        addToast({
          title: 'Ocorreu um erro durante a operação',
          type: 'error',
        });

        return;
      }

      try {
        setGroups((oldState) =>
          oldState.map((group) => {
            if (group.id === groupId) {
              return {
                ...group,
                products: (group?.products || []).map((product) => {
                  if (product.id === productId) {
                    return {
                      ...product,
                      pauseSale: status,
                    };
                  }

                  return product;
                }),
              };
            }

            return group;
          }),
        );

        await ProductsService.editProductStatus(
          user.empresa_id,
          groupId,
          productId,
          status,
        );
      } catch (error) {
        setGroups((oldState) =>
          oldState.map((group) => {
            if (group.id === groupId) {
              return groupProduct;
            }

            return group;
          }),
        );

        if (error instanceof APIError) {
          addToast({
            title: error.message,
            type: 'error',
          });

          return;
        }

        addToast({
          title: 'Ocorreu um erro durante a operação',
          type: 'error',
        });
      }
    },
    [user.empresa_id, groups, addToast],
  );

  const handleOnSortEnd = useCallback(async () => {
    try {
      setIsLoadingSort(true);

      if (groupsToSort.length > 0) {
        await GroupsService.sortGroups(
          user.empresa_id,
          groupsToSort.map((groupToSort) => ({
            id: groupToSort.id,
            order: groupToSort.order,
          })),
        );
      }

      if (activeGroup && productsToSort.length > 0) {
        await ProductsService.sortProducts(
          user.empresa_id,
          activeGroup,
          productsToSort.map((productToSort) => ({
            id: productToSort.id,
            order: productToSort.order,
          })),
        );
      }

      if (activeProduct && complementsToSort.length > 0) {
        await ComplementsService.sortComplements(
          user.empresa_id,
          activeProduct,
          complementsToSort.map((complementToSort) => ({
            id: complementToSort.id,
            order: complementToSort.order,
          })),
        );
      }

      if (activeComplement && complementItemsToSort.length > 0) {
        await ComplementItemsService.sortComplementItems(
          user.empresa_id,
          activeComplement,
          complementItemsToSort.map((complementItemToSort) => ({
            id: complementItemToSort.id,
            order: complementItemToSort.order,
          })),
        );
      }

      sortModalRef.current?.close();

      setTimeout(() => {
        setGroupsToSort([]);
        setProductsToSort([]);
        setComplementsToSort([]);
        setComplementItemsToSort([]);
        setActiveGroup(undefined);
        setActiveProduct(undefined);
        setActiveComplement(undefined);
      }, 500);

      handleLoadGroupsWithProducts();
    } catch (error) {
      if (error instanceof APIError) {
        addToast({
          title: error.message,
          type: 'error',
        });
      }
    } finally {
      setIsLoadingSort(false);
    }
  }, [
    activeGroup,
    groupsToSort,
    activeProduct,
    productsToSort,
    user.empresa_id,
    activeComplement,
    complementsToSort,
    complementItemsToSort,
    addToast,
    handleLoadGroupsWithProducts,
  ]);

  const handleCancelSortModal = useCallback(() => {
    sortModalRef.current?.close();

    setTimeout(() => {
      setGroupsToSort([]);
      setProductsToSort([]);
      setComplementsToSort([]);
      setComplementItemsToSort([]);
      setActiveGroup(undefined);
      setActiveProduct(undefined);
      setActiveComplement(undefined);
    }, 500);
  }, []);

  const hasPermission = useCallback(
    (): boolean => findRotinas('produtos')?.alterar || false,
    [findRotinas],
  );

  const handleDownloadLowStockReport = useCallback(async () => {
    if (!hasPermission()) {
      addToast({
        type: 'error',
        title: 'Não autorizado.',
        description: 'Você não tem permissão.',
      });
      return;
    }

    setIsDownloadingLowStock(true);

    try {
      const token = localStorage.getItem('@AtacDelivery:token');
      const params = new URLSearchParams();

      params.append('low_stock', String(showLowStockOnly));

      if (groupToSearch) {
        params.append('group_id', String(groupToSearch));
      }

      if (termToSearch) {
        params.append('product_name', termToSearch);
      }

      const url = `${process.env.REACT_APP_SERVER_URL}/companies/${user.empresa_id}/products/low-stock?${params.toString()}`;

      const response = await axios.get(url, {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const blobUrl = window.URL.createObjectURL(
        new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        }),
      );
      const link = document.createElement('a');
      link.href = blobUrl;
      link.setAttribute(
        'download',
        `produtos-estoque-baixo-${new Date().getTime()}.xlsx`,
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      addToast({
        type: 'error',
        title: 'Erro',
        description: 'Ocorreu um erro ao baixar o relatório de estoque baixo.',
      });
    } finally {
      setIsDownloadingLowStock(false);
    }
  }, [hasPermission, addToast, user.empresa_id, groupToSearch, showLowStockOnly, termToSearch]);

  const formatPhoneNumber = (value: string): string => {
    const digits = value.replace(/\D/g, '').slice(0, 11);

    if (digits.length <= 2) {
      return digits.length ? `(${digits}` : '';
    }
    if (digits.length <= 3) {
      return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
    }
    if (digits.length <= 7) {
      return `(${digits.slice(0, 2)}) ${digits.slice(2, 3)} ${digits.slice(3)}`;
    }
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 3)} ${digits.slice(3, 7)}-${digits.slice(7)}`;
  };

  const handlePhoneInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formatted = formatPhoneNumber(e.target.value);
    e.target.value = formatted;
  };

  const handleGetWhatsappLink = useCallback(async () => {
    const phoneValue = whatsappPhoneRef.current?.value || '';
    const rawPhone = phoneValue.replace(/\D/g, '');

    if (!rawPhone || rawPhone.length < 10) {
      addToast({
        type: 'error',
        title: 'Erro',
        description: 'Informe um número de telefone válido.',
      });
      return;
    }

    setIsLoadingWhatsapp(true);

    try {
      const token = localStorage.getItem('@AtacDelivery:token');
      const phoneWithCountry = `55${rawPhone}`;
      const params = new URLSearchParams();

      params.append('phone', phoneWithCountry);
      params.append('low_stock', String(showLowStockOnly));

      if (groupToSearch) {
        params.append('group_id', String(groupToSearch));
      }

      if (termToSearch) {
        params.append('product_name', termToSearch);
      }

      const url = `${process.env.REACT_APP_SERVER_URL}/companies/${user.empresa_id}/products/low-stock/whatsapp?${params.toString()}`;

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      window.open(response.data.url || response.data, '_blank');
      setShowWhatsappInput(false);
      if (whatsappPhoneRef.current) {
        whatsappPhoneRef.current.value = '';
      }
    } catch (error) {
      addToast({
        type: 'error',
        title: 'Erro',
        description: 'Ocorreu um erro ao gerar o link do WhatsApp.',
      });
    } finally {
      setIsLoadingWhatsapp(false);
    }
  }, [user.empresa_id, groupToSearch, showLowStockOnly, termToSearch, addToast]);

  const handleOpenSortModal = useCallback(() => {
    if (!hasPermission()) {
      addToast({
        type: 'error',
        title: 'Não autorizado.',
        description: 'Você não tem permissão.',
      });
      return;
    }
    sortModalRef.current?.open();

    setGroupsToSort(
      groups
        .sort((a, b) => a.order - b.order)
        .map((group) => ({
          id: group.id,
          name: group.name,
          order: group.order,
        })),
    );
  }, [addToast, groups, hasPermission]);

  const handleCreateSimpleProduct = useCallback(
    async (groupId: number) => {
      try {
        handleChangeSimpleProduct({
          groupId,
          unitOfMeasurementId: 6,
        });
        handleOpenSimpleProductDrawer();

        const unitsOfMeasurement = await UnitsOfMeasurementsService.listUnitsOfMeasurement(
          user.empresa_id,
        );

        handleChangeSimpleProductUnitsOfMeasurementOptions(
          unitsOfMeasurement.map((unitOfMeasurement) => ({
            value: unitOfMeasurement.id,
            label: `${capitalizeFirstLetter(
              unitOfMeasurement.name,
            )} (${unitOfMeasurement.acronym.toUpperCase()})`,
          })),
        );
        handleChangeSimpleProductGroupsOptions(
          groups
            .filter((group) => group.type === 1)
            .map((group) => ({
              value: group.id,
              label: group.name,
            })),
        );
      } catch (error) {
        if (error instanceof APIError) {
          addToast({
            title: error.message,
            type: 'error',
          });
        }
      }
    },
    [
      groups,
      user.empresa_id,
      addToast,
      handleChangeSimpleProductGroupsOptions,
      handleChangeSimpleProduct,
      handleChangeSimpleProductUnitsOfMeasurementOptions,
      handleOpenSimpleProductDrawer,
    ],
  );

  const handleCreatePizzaProduct = useCallback(
    async (groupId: number) => {
      try {
        handleChangePizzaProduct({
          groupId,
          unitOfMeasurementId: 6,
        });
        handleOpenPizzaProductDrawer();

        const unitsOfMeasurement = await UnitsOfMeasurementsService.listUnitsOfMeasurement(
          user.empresa_id,
        );

        handleChangePizzaProductUnitsOfMeasurementOptions(
          unitsOfMeasurement.map((unitOfMeasurement) => ({
            value: unitOfMeasurement.id,
            label: `${capitalizeFirstLetter(
              unitOfMeasurement.name,
            )} (${unitOfMeasurement.acronym.toUpperCase()})`,
          })),
        );
        handleChangePizzaProductGroupsOptions(
          groups
            .filter((group) => group.type === 3)
            .map((group) => ({
              value: group.id,
              label: group.name,
            })),
        );
      } catch (error) {
        if (error instanceof APIError) {
          addToast({
            title: error.message,
            type: 'error',
          });
        }
      }
    },
    [
      groups,
      user.empresa_id,
      addToast,
      handleChangePizzaProductGroupsOptions,
      handleChangePizzaProduct,
      handleChangePizzaProductUnitsOfMeasurementOptions,
      handleOpenPizzaProductDrawer,
    ],
  );

  const handleCreateGridProduct = useCallback(
    async (groupId: number) => {
      try {
        handleChangeGridProduct({
          groupId,
          unitOfMeasurementId: 6,
        });
        handleOpenGridProductDrawer();

        const unitsOfMeasurement = await UnitsOfMeasurementsService.listUnitsOfMeasurement(
          user.empresa_id,
        );

        handleChangeGridProductUnitsOfMeasurementOptions(
          unitsOfMeasurement.map((unitOfMeasurement) => ({
            value: unitOfMeasurement.id,
            label: `${capitalizeFirstLetter(
              unitOfMeasurement.name,
            )} (${unitOfMeasurement.acronym.toUpperCase()})`,
          })),
        );
        handleChangeGridProductGroupsOptions(
          groups
            .filter((group) => group.type === 2)
            .map((group) => ({
              value: group.id,
              label: group.name,
            })),
        );
      } catch (error) {
        if (error instanceof APIError) {
          addToast({
            title: error.message,
            type: 'error',
          });
        }
      }
    },
    [
      groups,
      user.empresa_id,
      addToast,
      handleChangeGridProductGroupsOptions,
      handleChangeGridProduct,
      handleChangeGridProductUnitsOfMeasurementOptions,
      handleOpenGridProductDrawer,
    ],
  );

  const handleEditSimpleProduct = useCallback(
    async (productId: number, groupId: number) => {
      try {
        addToast({
          title: 'Obtendo as informações do produto',
          type: 'info',
        });

        const product = await ProductsService.showProduct(
          user.empresa_id,
          productId,
          true,
        );

        if (!product) {
          throw new Error('Produto não encontrado');
        }

        const availabilityDetails =
          typeof product.availability.details === 'string'
            ? JSON.parse(product.availability.details)
            : product.availability.details;

        const unitsOfMeasurement = await UnitsOfMeasurementsService.listUnitsOfMeasurement(
          user.empresa_id,
        );

        handleChangeSimpleProductUnitsOfMeasurementOptions(
          unitsOfMeasurement.map((unitOfMeasurement) => ({
            value: unitOfMeasurement.id,
            label: `${capitalizeFirstLetter(
              unitOfMeasurement.name,
            )} (${unitOfMeasurement.acronym.toUpperCase()})`,
          })),
        );
        handleChangeSimpleProductGroupsOptions(
          groups
            .filter((group) => group.type === 1)
            .map((group) => ({
              value: group.id,
              label: group.name,
            })),
        );
        handleChangeSimpleProduct({
          groupId,
          unitOfMeasurementId: product.unitOfMeasurementId,
          code: product.code,
          currentStock: Number(product?.stock?.currentStock || 0),
          complements: (product.complements || []).map((complement: any) => ({
            id: Number(complement.id),
            order: Number(complement.order),
            name: complement.name,
            maximumQuantity: Number(complement.maximumQuantity || 0),
            minimumQuantity: Number(complement.minimumQuantity || 0),
            isRequired: complement.isRequired,
            type: Number(complement.type),
            pauseSale: Boolean(complement.pauseSale),
            items: complement.items.map((item: any) => ({
              id: Number(item.id),
              order: Number(item.order),
              name: item.name,
              maximumQuantity: Number(item.maximumQuantity || 0),
              minimumQuantity: Number(item.minimumQuantity || 0),
              rawMaterialId: Number(item.rawMaterialId),
              code: item.code,
              image: item.image,
              price: Number(item.price.value || 0),
              pauseSale: Boolean(item.pauseSale),
              checked: Boolean(item.checked),
            })),
          })),
          details: {
            days: {
              monday:
                typeof availabilityDetails?.dias?.segunda === 'boolean'
                  ? availabilityDetails.dias.segunda
                  : true,
              tuesday:
                typeof availabilityDetails?.dias?.terca === 'boolean'
                  ? availabilityDetails.dias.terca
                  : true,
              wednesday:
                typeof availabilityDetails?.dias?.quarta === 'boolean'
                  ? availabilityDetails.dias.quarta
                  : true,
              thursday:
                typeof availabilityDetails?.dias?.quinta === 'boolean'
                  ? availabilityDetails.dias.quinta
                  : true,
              friday:
                typeof availabilityDetails?.dias?.sexta === 'boolean'
                  ? availabilityDetails.dias.sexta
                  : true,
              saturday:
                typeof availabilityDetails?.dias?.sabado === 'boolean'
                  ? availabilityDetails.dias.sabado
                  : true,
              sunday:
                typeof availabilityDetails?.dias?.domingo === 'boolean'
                  ? availabilityDetails.dias.domingo
                  : true,
            },
            shifts: (availabilityDetails?.turnos || []).map((shift: any) => ({
              startTime: shift.inicio,
              endTime: shift.fim,
            })),
          },
          gtin: product.gtin,
          height: product?.dimensions?.height
            ? Number(product.dimensions.height)
            : undefined,
          id: productId,
          image: product.image,
          images: Array(6)
            .fill(undefined)
            .map((image, index) => {
              if (product.images[index]) {
                return {
                  id: product.images[index].id,
                  file: product.images[index].name,
                };
              }

              return image;
            }),
          isAwaysAvailability:
            Object.values(availabilityDetails?.dias || {}).every(
              (day) => day,
            ) && (availabilityDetails?.turnos || []).length === 0,
          length: product?.dimensions?.length
            ? Number(product.dimensions.length)
            : undefined,
          minimumStock: Number(product?.stock?.minimumStock || 0),
          name: product.name,
          hasDiscount: product?.discount
            ? Boolean(product.discount?.active)
            : false,
          newPrice: product?.discount
            ? Number(product?.price?.value || 0) -
              Number(product?.discount?.price || 0)
            : Number(product?.price?.value || 0),
          observation: product.observation,
          price: Number(product?.price?.value || 0),
          weight: product?.dimensions?.weight
            ? Number(product.dimensions.weight)
            : undefined,
          portion: product?.portion ? Number(product.portion) : undefined,
          productPortion: product.productPortion,
          width: product?.dimensions?.width
            ? Number(product.dimensions.width)
            : undefined,
          // Fiscal NFC-e (Story 1-4) — prefill p/ não regredir o dado ao salvar.
          categoriaFiscalId:
            product?.categoriaFiscalId != null
              ? Number(product.categoriaFiscalId)
              : undefined,
          ncmOverride: product?.ncmOverride ?? undefined,
          cfopOverride: product?.cfopOverride ?? undefined,
          cestOverride: product?.cestOverride ?? undefined,
          origemOverride: product?.origemOverride ?? undefined,
        });
        handleOpenSimpleProductDrawer();
      } catch (error) {
        if (error instanceof Error) {
          addToast({
            title: error.message,
            type: 'error',
          });
        }
      }
    },
    [
      groups,
      user.empresa_id,
      addToast,
      handleChangeSimpleProductGroupsOptions,
      handleChangeSimpleProduct,
      handleChangeSimpleProductUnitsOfMeasurementOptions,
      handleOpenSimpleProductDrawer,
    ],
  );

  const handleCloneSimpleProduct = useCallback(
    async (productId: number, groupId: number) => {
      try {
        addToast({
          title: 'Obtendo as informações do produto',
          type: 'info',
        });

        const product = await ProductsService.showProduct(
          user.empresa_id,
          productId,
          true,
        );

        if (!product) {
          throw new Error('Produto não encontrado');
        }

        const availabilityDetails =
          typeof product.availability.details === 'string'
            ? JSON.parse(product.availability.details)
            : product.availability.details;

        const unitsOfMeasurement = await UnitsOfMeasurementsService.listUnitsOfMeasurement(
          user.empresa_id,
        );

        const productImage = await handleDownloadImage(product?.image);

        const images: Array<Image | undefined> = [];

        await Promise.all(
          Array(6)
            .fill(undefined)
            .map(async (_, imageIndex) => {
              if (product.images[imageIndex]) {
                const image = await handleDownloadImage(
                  product.images[imageIndex]?.name,
                );

                images.push({
                  id: undefined,
                  file: image,
                });
              } else {
                images.push(undefined);
              }
            }),
        );

        const complements: any[] = [];

        await Promise.all(
          (product.complements || []).map(async (complement: any) => {
            const items: any[] = [];

            await Promise.all(
              complement.items.map(async (item: any) => {
                items.push({
                  id: String(Math.random()),
                  order: Number(item?.order || 1),
                  name: item.name,
                  maximumQuantity: Number(item?.maximumQuantity || 0),
                  minimumQuantity: Number(item?.minimumQuantity || 0),
                  rawMaterialId: item?.rawMaterialId
                    ? Number(item.rawMaterialId)
                    : undefined,
                  code: item.code,
                  image: await handleDownloadImage(item?.image),
                  price: Number(item?.price?.value || 0),
                  pauseSale: Boolean(item.pauseSale),
                  checked: Boolean(item.checked),
                });
              }),
            );

            complements.push({
              id: String(Math.random()),
              order: Number(complement?.order || 1),
              name: complement.name,
              maximumQuantity: Number(complement?.maximumQuantity || 0),
              minimumQuantity: Number(complement?.minimumQuantity || 0),
              isRequired: Boolean(complement.isRequired),
              type: Number(complement.type),
              pauseSale: Boolean(complement.pauseSale),
              items,
            });
          }),
        );

        handleChangeSimpleProductUnitsOfMeasurementOptions(
          unitsOfMeasurement.map((unitOfMeasurement) => ({
            value: unitOfMeasurement.id,
            label: `${capitalizeFirstLetter(
              unitOfMeasurement.name,
            )} (${unitOfMeasurement.acronym.toUpperCase()})`,
          })),
        );
        handleChangeSimpleProductGroupsOptions(
          groups
            .filter((group) => group.type === 1)
            .map((group) => ({
              value: group.id,
              label: group.name,
            })),
        );
        handleChangeSimpleProduct({
          groupId,
          unitOfMeasurementId: product.unitOfMeasurementId,
          code: undefined,
          currentStock: Number(product?.stock?.currentStock || 0),
          portion: product?.portion ? Number(product.portion) : undefined,
          productPortion: product.productPortion,
          complements,
          details: {
            days: {
              monday:
                typeof availabilityDetails?.dias?.segunda === 'boolean'
                  ? availabilityDetails.dias.segunda
                  : true,
              tuesday:
                typeof availabilityDetails?.dias?.terca === 'boolean'
                  ? availabilityDetails.dias.terca
                  : true,
              wednesday:
                typeof availabilityDetails?.dias?.quarta === 'boolean'
                  ? availabilityDetails.dias.quarta
                  : true,
              thursday:
                typeof availabilityDetails?.dias?.quinta === 'boolean'
                  ? availabilityDetails.dias.quinta
                  : true,
              friday:
                typeof availabilityDetails?.dias?.sexta === 'boolean'
                  ? availabilityDetails.dias.sexta
                  : true,
              saturday:
                typeof availabilityDetails?.dias?.sabado === 'boolean'
                  ? availabilityDetails.dias.sabado
                  : true,
              sunday:
                typeof availabilityDetails?.dias?.domingo === 'boolean'
                  ? availabilityDetails.dias.domingo
                  : true,
            },
            shifts: (availabilityDetails?.turnos || []).map((shift: any) => ({
              startTime: shift.inicio,
              endTime: shift.fim,
            })),
          },
          gtin: undefined,
          height: product?.dimensions?.height
            ? Number(product.dimensions.height)
            : undefined,
          image: productImage,
          images: images.sort(),
          isAwaysAvailability:
            Object.values(availabilityDetails?.dias || {}).every(
              (day) => day,
            ) && (availabilityDetails?.turnos || []).length === 0,
          length: product?.dimensions?.length
            ? Number(product.dimensions.length)
            : undefined,
          minimumStock: Number(product?.stock?.minimumStock || 0),
          name: `Clone de ${product.name}`,
          hasDiscount: product?.discount
            ? Boolean(product.discount?.active)
            : false,
          newPrice: product?.discount
            ? Number(product?.price?.value || 0) -
              Number(product?.discount?.price || 0)
            : Number(product?.price?.value || 0),
          observation: product.observation,
          price: Number(product?.price?.value || 0),
          weight: product?.dimensions?.weight
            ? Number(product.dimensions.weight)
            : undefined,
          width: product?.dimensions?.width
            ? Number(product.dimensions.width)
            : undefined,
        });
        handleOpenSimpleProductDrawer();
      } catch (error) {
        console.error(error);
        if (error instanceof Error) {
          addToast({
            title: error.message,
            type: 'error',
          });
        }
      }
    },
    [
      groups,
      user.empresa_id,
      addToast,
      handleChangeSimpleProductGroupsOptions,
      handleChangeSimpleProduct,
      handleChangeSimpleProductUnitsOfMeasurementOptions,
      handleOpenSimpleProductDrawer,
    ],
  );

  const handleEditPizzaProduct = useCallback(
    async (productId: number, groupId: number) => {
      try {
        addToast({
          title: 'Obtendo as informações do produto',
          type: 'info',
        });

        const product = await ProductsService.showProduct(
          user.empresa_id,
          productId,
          true,
        );

        if (!product) {
          throw new Error('Produto não encontrado');
        }

        const availabilityDetails =
          typeof product.availability.details === 'string'
            ? JSON.parse(product.availability.details)
            : product.availability.details;

        const unitsOfMeasurement = await UnitsOfMeasurementsService.listUnitsOfMeasurement(
          user.empresa_id,
        );

        handleChangePizzaProductUnitsOfMeasurementOptions(
          unitsOfMeasurement.map((unitOfMeasurement) => ({
            value: unitOfMeasurement.id,
            label: `${capitalizeFirstLetter(
              unitOfMeasurement.name,
            )} (${unitOfMeasurement.acronym.toUpperCase()})`,
          })),
        );
        handleChangePizzaProductGroupsOptions(
          groups
            .filter((group) => group.type === 3)
            .map((group) => ({
              value: group.id,
              label: group.name,
            })),
        );
        if (product.display) {
          handleChangeDisplay(product.display);
          handleChangeSelectedGrid((product.grids || [])[0].sizeId);
          handleChangeSelectedNumOfFlavors(
            Number((product.grids || [])[0].numberOfFlavors),
          );
        }
        handleChangePizzaProduct({
          groupId,
          unitOfMeasurementId: product.unitOfMeasurementId,
          complements: (product.complements || []).map((complement: any) => ({
            id: Number(complement.id),
            order: Number(complement.order),
            name: complement.name,
            maximumQuantity: Number(complement.maximumQuantity),
            minimumQuantity: Number(complement.minimumQuantity),
            isRequired: complement.isRequired,
            type: Number(complement.type),
            pauseSale: Boolean(complement.pauseSale),
            items: complement.items.map((item: any) => ({
              id: Number(item.id),
              order: Number(item.order),
              name: item.name,
              maximumQuantity: Number(item.maximumQuantity),
              minimumQuantity: Number(item.minimumQuantity),
              rawMaterialId: Number(item.rawMaterialId),
              code: item.code,
              image: item.image,
              price: item?.price ? Number(item.price.value) : 0,
              pauseSale: Boolean(item.pauseSale),
              checked: Boolean(item.checked),
            })),
          })),
          details: {
            days: {
              monday:
                typeof availabilityDetails?.dias?.segunda === 'boolean'
                  ? availabilityDetails.dias.segunda
                  : true,
              tuesday:
                typeof availabilityDetails?.dias?.terca === 'boolean'
                  ? availabilityDetails.dias.terca
                  : true,
              wednesday:
                typeof availabilityDetails?.dias?.quarta === 'boolean'
                  ? availabilityDetails.dias.quarta
                  : true,
              thursday:
                typeof availabilityDetails?.dias?.quinta === 'boolean'
                  ? availabilityDetails.dias.quinta
                  : true,
              friday:
                typeof availabilityDetails?.dias?.sexta === 'boolean'
                  ? availabilityDetails.dias.sexta
                  : true,
              saturday:
                typeof availabilityDetails?.dias?.sabado === 'boolean'
                  ? availabilityDetails.dias.sabado
                  : true,
              sunday:
                typeof availabilityDetails?.dias?.domingo === 'boolean'
                  ? availabilityDetails.dias.domingo
                  : true,
            },
            shifts: (availabilityDetails?.turnos || []).map((shift: any) => ({
              startTime: shift.inicio,
              endTime: shift.fim,
            })),
          },
          gtin: product.gtin,
          id: productId,
          image: product.image,
          display: product.display,
          images: Array(6)
            .fill(undefined)
            .map((image, index) => {
              if (product.images[index]) {
                return {
                  id: product.images[index].id,
                  file: product.images[index].name,
                };
              }

              return image;
            }),
          isAwaysAvailability:
            Object.values(availabilityDetails?.dias || {}).every(
              (day) => day,
            ) && (availabilityDetails?.turnos || []).length === 0,
          name: product.name,
          observation: product.observation,
          grids: (product.grids || []).map((grid: any) => ({
            id: grid.id,
            name: grid.name,
            active: grid.active,
            currentStock: grid?.stock ? Number(grid.stock.currentStock) : 0,
            minimumStock: grid?.stock ? Number(grid.stock.minimumStock) : 0,
            discount: grid?.discount ? Number(grid.discount.value) * 100 : 0,
            numberOfFlavors: Number(grid.numberOfFlavors),
            numberOfSlices: Number(grid.numberOfSlices),
            order: Number(grid.order),
            price: grid?.price ? Number(grid.price.value) : 0,
            sizeId: grid.sizeId,
            code: grid.code,
            image: grid.image,
            canChangeCurrentStock: false,
          })),
        });
        handleOpenPizzaProductDrawer();
      } catch (error) {
        console.error(error);
        if (error instanceof Error) {
          addToast({
            title: error.message,
            type: 'error',
          });
        }
      }
    },
    [
      groups,
      user.empresa_id,
      addToast,
      handleChangeDisplay,
      handleChangeSelectedGrid,
      handleChangeSelectedNumOfFlavors,
      handleChangePizzaProductGroupsOptions,
      handleChangePizzaProduct,
      handleChangePizzaProductUnitsOfMeasurementOptions,
      handleOpenPizzaProductDrawer,
    ],
  );

  const handleClonePizzaProduct = useCallback(
    async (productId: number, groupId: number) => {
      try {
        addToast({
          title: 'Obtendo as informações do produto',
          type: 'info',
        });

        const product = await ProductsService.showProduct(
          user.empresa_id,
          productId,
          true,
        );

        if (!product) {
          throw new Error('Produto não encontrado');
        }

        const availabilityDetails =
          typeof product.availability.details === 'string'
            ? JSON.parse(product.availability.details)
            : product.availability.details;

        const unitsOfMeasurement = await UnitsOfMeasurementsService.listUnitsOfMeasurement(
          user.empresa_id,
        );

        const productImage = await handleDownloadImage(product?.image);

        const images: Array<Image | undefined> = [];

        await Promise.all(
          Array(6)
            .fill(undefined)
            .map(async (_, imageIndex) => {
              if (product.images[imageIndex]) {
                const image = await handleDownloadImage(
                  product.images[imageIndex]?.name,
                );

                images.push({
                  id: undefined,
                  file: image,
                });
              } else {
                images.push(undefined);
              }
            }),
        );

        const complements: any[] = [];

        await Promise.all(
          (product.complements || []).map(async (complement: any) => {
            const items: any[] = [];

            await Promise.all(
              complement.items.map(async (item: any) => {
                items.push({
                  id: String(Math.random()),
                  order: Number(item?.order || 1),
                  name: item.name,
                  maximumQuantity: Number(item?.maximumQuantity || 0),
                  minimumQuantity: Number(item?.minimumQuantity || 0),
                  rawMaterialId: item?.rawMaterialId
                    ? Number(item.rawMaterialId)
                    : undefined,
                  code: item.code,
                  image: await handleDownloadImage(item?.image),
                  price: Number(item?.price?.value || 0),
                  pauseSale: Boolean(item.pauseSale),
                  checked: Boolean(item.checked),
                });
              }),
            );

            complements.push({
              id: String(Math.random()),
              order: Number(complement?.order || 1),
              name: complement.name,
              maximumQuantity: Number(complement?.maximumQuantity || 0),
              minimumQuantity: Number(complement?.minimumQuantity || 0),
              isRequired: Boolean(complement.isRequired),
              type: Number(complement.type),
              pauseSale: Boolean(complement.pauseSale),
              items,
            });
          }),
        );

        handleChangePizzaProductUnitsOfMeasurementOptions(
          unitsOfMeasurement.map((unitOfMeasurement) => ({
            value: unitOfMeasurement.id,
            label: `${capitalizeFirstLetter(
              unitOfMeasurement.name,
            )} (${unitOfMeasurement.acronym.toUpperCase()})`,
          })),
        );
        if (product.display) {
          handleChangeDisplay(product.display);
          handleChangeSelectedGrid((product.grids || [])[0].sizeId);
          handleChangeSelectedNumOfFlavors(
            Number((product.grids || [])[0].numberOfFlavors),
          );
        }

        handleChangePizzaProductGroupsOptions(
          groups
            .filter((group) => group.type === 3)
            .map((group) => ({
              value: group.id,
              label: group.name,
            })),
        );
        handleChangePizzaProduct({
          groupId,
          unitOfMeasurementId: product.unitOfMeasurementId,
          complements,
          display: product.display,
          details: {
            days: {
              monday:
                typeof availabilityDetails?.dias?.segunda === 'boolean'
                  ? availabilityDetails.dias.segunda
                  : true,
              tuesday:
                typeof availabilityDetails?.dias?.terca === 'boolean'
                  ? availabilityDetails.dias.terca
                  : true,
              wednesday:
                typeof availabilityDetails?.dias?.quarta === 'boolean'
                  ? availabilityDetails.dias.quarta
                  : true,
              thursday:
                typeof availabilityDetails?.dias?.quinta === 'boolean'
                  ? availabilityDetails.dias.quinta
                  : true,
              friday:
                typeof availabilityDetails?.dias?.sexta === 'boolean'
                  ? availabilityDetails.dias.sexta
                  : true,
              saturday:
                typeof availabilityDetails?.dias?.sabado === 'boolean'
                  ? availabilityDetails.dias.sabado
                  : true,
              sunday:
                typeof availabilityDetails?.dias?.domingo === 'boolean'
                  ? availabilityDetails.dias.domingo
                  : true,
            },
            shifts: (availabilityDetails?.turnos || []).map((shift: any) => ({
              startTime: shift.inicio,
              endTime: shift.fim,
            })),
          },
          gtin: undefined,
          image: productImage,
          images: images.sort(),
          isAwaysAvailability:
            Object.values(availabilityDetails?.dias || {}).every(
              (day) => day,
            ) && (availabilityDetails?.turnos || []).length === 0,
          name: `Clone de ${product.name}`,
          observation: product.observation,
          isCloning: true,
          grids: (product.grids || []).map((grid: any) => ({
            id: String(Math.random()),
            name: grid.name,
            active: grid.active,
            emphasis: grid.emphasis,
            currentStock: grid?.stock ? Number(grid.stock.currentStock) : 0,
            minimumStock: grid?.stock ? Number(grid.stock.minimumStock) : 0,
            discount: grid?.discount ? Number(grid.discount.value) * 100 : 0,
            numberOfFlavors: Number(grid.numberOfFlavors),
            numberOfSlices: Number(grid.numberOfSlices),
            order: Number(grid.order),
            price: grid?.price ? Number(grid.price.value) : 0,
            sizeId: grid.sizeId,
            code: undefined,
            image: grid.image,
            canChangeCurrentStock: false,
          })),
        });
        handleOpenPizzaProductDrawer();
      } catch (error) {
        console.error(error);
        if (error instanceof Error) {
          addToast({
            title: error.message,
            type: 'error',
          });
        }
      }
    },
    [
      groups,
      user.empresa_id,
      addToast,
      handleChangeDisplay,
      handleChangePizzaProductGroupsOptions,
      handleChangePizzaProduct,
      handleChangeSelectedGrid,
      handleChangeSelectedNumOfFlavors,
      handleChangePizzaProductUnitsOfMeasurementOptions,
      handleOpenPizzaProductDrawer,
    ],
  );

  const handleEditGridProduct = useCallback(
    async (productId: number, groupId: number) => {
      try {
        addToast({
          title: 'Obtendo as informações do produto',
          type: 'info',
        });

        const product = await ProductsService.showProduct(
          user.empresa_id,
          productId,
          true,
        );

        if (!product) {
          throw new Error('Produto não encontrado');
        }

        const availabilityDetails =
          typeof product.availability.details === 'string'
            ? JSON.parse(product.availability.details)
            : product.availability.details;

        const unitsOfMeasurement = await UnitsOfMeasurementsService.listUnitsOfMeasurement(
          user.empresa_id,
        );

        const colors = await ColorsService.listColors(user.empresa_id);

        const sizes = await SizesService.listSizes(user.empresa_id, 2);

        handleChangeGridProductUnitsOfMeasurementOptions(
          unitsOfMeasurement.map((unitOfMeasurement) => ({
            value: unitOfMeasurement.id,
            label: `${capitalizeFirstLetter(
              unitOfMeasurement.name,
            )} (${unitOfMeasurement.acronym.toUpperCase()})`,
          })),
        );
        handleChangeGridProductGroupsOptions(
          groups
            .filter((group) => group.type === 2)
            .map((group) => ({
              value: group.id,
              label: group.name,
            })),
        );
        handleChangeGridProduct({
          groupId,
          unitOfMeasurementId: product.unitOfMeasurementId,
          height: product?.dimensions?.height
            ? Number(product.dimensions.height)
            : undefined,
          length: product?.dimensions?.length
            ? Number(product.dimensions.length)
            : undefined,
          weight: product?.dimensions?.weight
            ? Number(product.dimensions.weight)
            : undefined,
          width: product?.dimensions?.width
            ? Number(product.dimensions.width)
            : undefined,
          complements: (product.complements || []).map((complement: any) => ({
            id: Number(complement.id),
            order: Number(complement.order),
            name: complement.name,
            maximumQuantity: Number(complement.maximumQuantity),
            minimumQuantity: Number(complement.minimumQuantity),
            isRequired: complement.isRequired,
            type: Number(complement.type),
            pauseSale: Boolean(complement.pauseSale),
            items: complement.items.map((item: any) => ({
              id: Number(item.id),
              order: Number(item.order),
              name: item.name,
              maximumQuantity: Number(item.maximumQuantity),
              minimumQuantity: Number(item.minimumQuantity),
              rawMaterialId: Number(item.rawMaterialId),
              code: item.code,
              image: item.image,
              price: item?.price ? Number(item.price.value) : 0,
              pauseSale: Boolean(item.pauseSale),
              checked: Boolean(item.checked),
            })),
          })),
          details: {
            days: {
              monday:
                typeof availabilityDetails?.dias?.segunda === 'boolean'
                  ? availabilityDetails.dias.segunda
                  : true,
              tuesday:
                typeof availabilityDetails?.dias?.terca === 'boolean'
                  ? availabilityDetails.dias.terca
                  : true,
              wednesday:
                typeof availabilityDetails?.dias?.quarta === 'boolean'
                  ? availabilityDetails.dias.quarta
                  : true,
              thursday:
                typeof availabilityDetails?.dias?.quinta === 'boolean'
                  ? availabilityDetails.dias.quinta
                  : true,
              friday:
                typeof availabilityDetails?.dias?.sexta === 'boolean'
                  ? availabilityDetails.dias.sexta
                  : true,
              saturday:
                typeof availabilityDetails?.dias?.sabado === 'boolean'
                  ? availabilityDetails.dias.sabado
                  : true,
              sunday:
                typeof availabilityDetails?.dias?.domingo === 'boolean'
                  ? availabilityDetails.dias.domingo
                  : true,
            },
            shifts: (availabilityDetails?.turnos || []).map((shift: any) => ({
              startTime: shift.inicio,
              endTime: shift.fim,
            })),
          },
          gtin: product.gtin,
          id: productId,
          image: product.image,
          isAwaysAvailability:
            Object.values(availabilityDetails?.dias || {}).every(
              (day) => day,
            ) && (availabilityDetails?.turnos || []).length === 0,
          name: product.name,
          observation: product.observation,
          grids: (product.grids || []).map((grid: any) => ({
            id: grid.id,
            name: grid.name,
            active: grid.active,
            emphasis: grid.emphasis,
            currentStock: grid?.stock ? Number(grid.stock.currentStock) : 0,
            minimumStock: grid?.stock ? Number(grid.stock.minimumStock) : 0,
            discount: grid?.discount ? Number(grid.discount.value) * 100 : 0,
            order: Number(grid.order),
            price: grid?.price ? Number(grid.price.value) : 0,
            sizeId: grid.sizeId,
            colorId: grid.colorId,
            code: grid.code,
            image: grid.image,
            canChangeCurrentStock: false,
            images: Array(3)
              .fill(undefined)
              .map((image, index) => {
                if (grid.images[index]) {
                  return {
                    id: grid.images[index].id,
                    file: grid.images[index].name,
                  };
                }

                return image;
              }),
            size: sizes
              .map((size) => ({
                value: size.id,
                label: size.name,
              }))
              .find((size) => size.value === grid.sizeId),
            color: colors
              .map((color) => ({
                value: color.id,
                label: color.name,
              }))
              .find((color) => color.value === grid.colorId),
          })),
        });
        handleOpenGridProductDrawer();
      } catch (error) {
        console.error(error);
        if (error instanceof Error) {
          addToast({
            title: error.message,
            type: 'error',
          });
        }
      }
    },
    [
      groups,
      user.empresa_id,
      addToast,
      handleChangeGridProductGroupsOptions,
      handleChangeGridProduct,
      handleChangeGridProductUnitsOfMeasurementOptions,
      handleOpenGridProductDrawer,
    ],
  );

  const handleCloneGridProduct = useCallback(
    async (productId: number, groupId: number) => {
      try {
        addToast({
          title: 'Obtendo as informações do produto',
          type: 'info',
        });

        const product = await ProductsService.showProduct(
          user.empresa_id,
          productId,
          true,
        );

        if (!product) {
          throw new Error('Produto não encontrado');
        }

        const availabilityDetails =
          typeof product.availability.details === 'string'
            ? JSON.parse(product.availability.details)
            : product.availability.details;

        const unitsOfMeasurement = await UnitsOfMeasurementsService.listUnitsOfMeasurement(
          user.empresa_id,
        );

        const colors = await ColorsService.listColors(user.empresa_id);

        const sizes = await SizesService.listSizes(user.empresa_id, 2);

        const productImage = await handleDownloadImage(product?.image);

        const grids: any[] = [];

        await Promise.all(
          (product.grids || []).map(async (grid: any) => {
            const images: Array<Image | undefined> = [];

            await Promise.all(
              Array(3)
                .fill(undefined)
                .map(async (_, imageIndex) => {
                  if (grid.images[imageIndex]) {
                    const image = await handleDownloadImage(
                      grid.images[imageIndex]?.name,
                    );

                    images.push({
                      id: undefined,
                      file: image,
                    });
                  } else {
                    images.push(undefined);
                  }
                }),
            );

            grids.push({
              id: String(Math.random()),
              name: grid.name,
              active: grid.active,
              emphasis: grid.emphasis,
              currentStock: grid?.stock ? Number(grid.stock.currentStock) : 0,
              minimumStock: grid?.stock ? Number(grid.stock.minimumStock) : 0,
              discount: grid?.discount ? Number(grid.discount.value) * 100 : 0,
              order: Number(grid.order),
              price: grid?.price ? Number(grid.price.value) : 0,
              sizeId: grid.sizeId,
              colorId: grid.colorId,
              code: undefined,
              image: grid.image,
              canChangeCurrentStock: false,
              images: images.sort(),
              size: sizes
                .map((size) => ({
                  value: size.id,
                  label: size.name,
                }))
                .find((size) => size.value === grid.sizeId),
              color: colors
                .map((color) => ({
                  value: color.id,
                  label: color.name,
                }))
                .find((color) => color.value === grid.colorId),
            });
          }),
        );

        const complements: any[] = [];

        await Promise.all(
          (product.complements || []).map(async (complement: any) => {
            const items: any[] = [];

            await Promise.all(
              complement.items.map(async (item: any) => {
                items.push({
                  id: String(Math.random()),
                  order: Number(item?.order || 1),
                  name: item.name,
                  maximumQuantity: Number(item?.maximumQuantity || 0),
                  minimumQuantity: Number(item?.minimumQuantity || 0),
                  rawMaterialId: item?.rawMaterialId
                    ? Number(item.rawMaterialId)
                    : undefined,
                  code: item.code,
                  image: await handleDownloadImage(item?.image),
                  price: Number(item?.price?.value || 0),
                  pauseSale: Boolean(item.pauseSale),
                  checked: Boolean(item.checked),
                });
              }),
            );

            complements.push({
              id: String(Math.random()),
              order: Number(complement?.order || 1),
              name: complement.name,
              maximumQuantity: Number(complement?.maximumQuantity || 0),
              minimumQuantity: Number(complement?.minimumQuantity || 0),
              isRequired: Boolean(complement.isRequired),
              type: Number(complement.type),
              pauseSale: Boolean(complement.pauseSale),
              items,
            });
          }),
        );

        handleChangeGridProductUnitsOfMeasurementOptions(
          unitsOfMeasurement.map((unitOfMeasurement) => ({
            value: unitOfMeasurement.id,
            label: `${capitalizeFirstLetter(
              unitOfMeasurement.name,
            )} (${unitOfMeasurement.acronym.toUpperCase()})`,
          })),
        );
        handleChangeGridProductGroupsOptions(
          groups
            .filter((group) => group.type === 2)
            .map((group) => ({
              value: group.id,
              label: group.name,
            })),
        );
        handleChangeGridProduct({
          groupId,
          unitOfMeasurementId: product.unitOfMeasurementId,
          complements,
          height: product?.dimensions?.height
            ? Number(product.dimensions.height)
            : undefined,
          length: product?.dimensions?.length
            ? Number(product.dimensions.length)
            : undefined,
          weight: product?.dimensions?.weight
            ? Number(product.dimensions.weight)
            : undefined,
          width: product?.dimensions?.width
            ? Number(product.dimensions.width)
            : undefined,
          details: {
            days: {
              monday:
                typeof availabilityDetails?.dias?.segunda === 'boolean'
                  ? availabilityDetails.dias.segunda
                  : true,
              tuesday:
                typeof availabilityDetails?.dias?.terca === 'boolean'
                  ? availabilityDetails.dias.terca
                  : true,
              wednesday:
                typeof availabilityDetails?.dias?.quarta === 'boolean'
                  ? availabilityDetails.dias.quarta
                  : true,
              thursday:
                typeof availabilityDetails?.dias?.quinta === 'boolean'
                  ? availabilityDetails.dias.quinta
                  : true,
              friday:
                typeof availabilityDetails?.dias?.sexta === 'boolean'
                  ? availabilityDetails.dias.sexta
                  : true,
              saturday:
                typeof availabilityDetails?.dias?.sabado === 'boolean'
                  ? availabilityDetails.dias.sabado
                  : true,
              sunday:
                typeof availabilityDetails?.dias?.domingo === 'boolean'
                  ? availabilityDetails.dias.domingo
                  : true,
            },
            shifts: (availabilityDetails?.turnos || []).map((shift: any) => ({
              startTime: shift.inicio,
              endTime: shift.fim,
            })),
          },
          gtin: undefined,
          image: productImage,
          isAwaysAvailability:
            Object.values(availabilityDetails?.dias || {}).every(
              (day) => day,
            ) && (availabilityDetails?.turnos || []).length === 0,
          name: `Clone de ${product.name}`,
          observation: product.observation,
          grids,
        });
        handleOpenGridProductDrawer();
      } catch (error) {
        console.error(error);
        if (error instanceof Error) {
          addToast({
            title: error.message,
            type: 'error',
          });
        }
      }
    },
    [
      groups,
      user.empresa_id,
      addToast,
      handleChangeGridProductGroupsOptions,
      handleChangeGridProduct,
      handleChangeGridProductUnitsOfMeasurementOptions,
      handleOpenGridProductDrawer,
    ],
  );

  const handleDeleteProduct = useCallback(
    async (productId: number, groupId: number) => {
      const groupToDeleteProduct = groups.find((group) => group.id === groupId);

      if (!groupToDeleteProduct) {
        addToast({
          title: 'Ocorreu um erro durante a operação',
          type: 'error',
        });

        return;
      }

      const productToBeDeleted = (groupToDeleteProduct?.products || []).find(
        (product) => product.id === productId,
      );

      if (!productToBeDeleted) {
        addToast({
          title: 'Ocorreu um erro durante a operação',
          type: 'error',
        });

        return;
      }

      try {
        setGroups((oldState) =>
          oldState.map((group) => {
            if (group.id === groupId) {
              return {
                ...group,
                products: (group.products || []).filter(
                  (product) => product.id !== productId,
                ),
              };
            }

            return group;
          }),
        );

        await ProductsService.deleteProduct(user.empresa_id, productId);

        addToast({
          title: 'Produto excluído com sucesso!',
          type: 'success',
        });
      } catch (error) {
        setGroups((oldState) =>
          oldState.map((group) => {
            if (group.id === groupId) {
              return {
                ...group,
                products: [...(group.products || []), productToBeDeleted].sort(
                  (a, b) => a?.order - b?.order,
                ),
              };
            }

            return group;
          }),
        );

        if (error instanceof APIError) {
          addToast({
            title: error.message,
            type: 'error',
          });

          return;
        }

        addToast({
          title: 'Ocorreu um erro durante a operação',
          type: 'error',
        });
      }
    },
    [groups, user.empresa_id, addToast],
  );

  const handleAttemptToEditProductImage = useCallback(
    (productId: number, groupId: number, productImage?: File | string) => {
      setUpdateProductImage({
        groupId,
        id: productId,
        image: productImage,
      });
      updateImageModalRef.current?.open();
    },
    [],
  );

  const handleEditProductImage = useCallback(async () => {
    if (!updateProductImage?.id || !updateProductImage?.groupId) return;

    const groupProduct = groups.find(
      (group) => group.id === updateProductImage.groupId,
    );

    if (!groupProduct) {
      addToast({
        title: 'Ocorreu um erro durante a operação',
        type: 'error',
      });

      return;
    }

    const productToUpdate = (groupProduct?.products || []).find(
      (product) => product.id === updateProductImage.id,
    );

    if (!productToUpdate) {
      addToast({
        title: 'Ocorreu um erro durante a operação',
        type: 'error',
      });

      return;
    }

    try {
      setIsLoadingUpdateProductImage(true);

      const formData = new FormData();

      if (updateProductImage?.image instanceof File) {
        formData.append('image', updateProductImage.image);
      }

      if (typeof updateProductImage?.image === 'string') {
        const productImage = await handleDownloadImage(
          updateProductImage?.image,
        );

        if (productImage instanceof File) {
          formData.append('image', productImage);
        }
      }

      const updatedProduct = await ProductsService.editProductImage(
        user.empresa_id,
        updateProductImage.groupId,
        updateProductImage.id,
        formData,
      );

      setGroups((oldState) =>
        oldState.map((group) => {
          if (group.id === updateProductImage.groupId) {
            return {
              ...group,
              products: (group?.products || []).map((product) => {
                if (product.id === updateProductImage.id) {
                  return {
                    ...product,
                    image: updatedProduct.image,
                  };
                }

                return product;
              }),
            };
          }

          return group;
        }),
      );

      updateImageModalRef.current?.close();
      setUpdateProductImage(undefined);
    } catch (error) {
      if (error instanceof APIError) {
        addToast({
          title: error.message,
          type: 'error',
        });

        return;
      }

      addToast({
        title: 'Ocorreu um erro durante a operação',
        type: 'error',
      });
    } finally {
      setIsLoadingUpdateProductImage(false);
    }
  }, [updateProductImage, groups, user.empresa_id, addToast]);

  const handleCancelProductImageEditing = useCallback(() => {
    updateImageModalRef.current?.close();
    setUpdateProductImage(undefined);
  }, []);

  useEffect(() => {
    if (searchProductsRef.current) {
      searchProductsRef.current.addEventListener(
        'input',
        debounce(() => {
          setTermToSearch(
            String(searchProductsRef.current?.value || '').toLowerCase(),
          );
        }, 750),
      );
    }
  }, []);

  useEffect(() => {
    handleLoadGroupsWithProducts();
  }, [handleLoadGroupsWithProducts]);

  const searchGroupsOptions: SelectOptionType[] = [
    { value: 0, label: 'Todas as categorias' },
    ...groups.map((group) => ({
      value: group.id,
      label: group.name,
    })),
  ];

  useEffect(() => {
    if (complementItemsToSort.length > 0) {
      setModalReordenarIsOpen('itens');
    } else if (complementsToSort.length > 0) {
      setModalReordenarIsOpen('complementos');
    } else if (productsToSort.length > 0) {
      setModalReordenarIsOpen('produtos');
    } else {
      setModalReordenarIsOpen('grupos');
    }
  }, [groupsToSort, productsToSort, complementsToSort, complementItemsToSort]);

  return (
    <Container>
      <Wrapper>
        <PageHeader>
          <div style={{ width: '100%' }}>
            <div className="title">
              <h1>Produtos</h1>
              <p>
                Produtos cadastrados: <span>{countProducts()}</span>
              </p>
            </div>
            <h3>
              Aqui você pode criar e editar seus grupos e produtos além de
              alterar preços e definir disponibilidade para seus itens
            </h3>
          </div>
        </PageHeader>
        <PageHeaderActions>
          <div>
            <Button
              onClick={() => selectGroupModalRef.current?.open()}
              disabled={!hasPermission()}
            >
              <FaPlus />
              Adicionar grupo
            </Button>
            <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
            <label
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                cursor: 'pointer',
                whiteSpace: 'nowrap',
                fontSize: '14px',
                color: '#666',
                padding: '8px 12px',
                borderRadius: '8px',
                border: showLowStockOnly ? '2px solid #f44336' : '2px solid #ddd',
                backgroundColor: showLowStockOnly ? '#ffebee' : 'transparent',
              }}
            >
              <input
                type="checkbox"
                checked={showLowStockOnly}
                onChange={(e) => setShowLowStockOnly(e.target.checked)}
                style={{ cursor: 'pointer', width: '16px', height: '16px' }}
              />
              Estoque baixo
            </label>
            <p onClick={handleOpenSortModal}>
              <BiMenu /> <span>Reordenar</span>
            </p>
              <p
                onClick={handleDownloadLowStockReport}
                style={{
                  opacity: isDownloadingLowStock ? 0.6 : 1,
                  pointerEvents: isDownloadingLowStock ? 'none' : 'auto',
                }}
              >
                <BiDownload />{' '}
                <span>
                  {isDownloadingLowStock ? 'Baixando...' : 'Baixar relatório'}
                </span>
              </p>
              {showWhatsappInput ? (
                <div
                  style={{
                    display: 'flex',
                    gap: '8px',
                    alignItems: 'center',
                  }}
                >
                  <input
                    ref={whatsappPhoneRef}
                    type="text"
                    placeholder="(11) 9 9999-9999"
                    onChange={handlePhoneInputChange}
                    style={{
                      padding: '8px 12px',
                      borderRadius: '8px',
                      border: '1px solid #ddd',
                      fontSize: '14px',
                      width: '160px',
                    }}
                  />
                  <button
                    type="button"
                    onClick={handleGetWhatsappLink}
                    disabled={isLoadingWhatsapp}
                    style={{
                      padding: '8px 16px',
                      borderRadius: '8px',
                      border: 'none',
                      backgroundColor: '#2fa45a',
                      color: '#fff',
                      cursor: isLoadingWhatsapp ? 'not-allowed' : 'pointer',
                      opacity: isLoadingWhatsapp ? 0.6 : 1,
                      fontSize: '14px',
                    }}
                  >
                    {isLoadingWhatsapp ? 'Enviando...' : 'Enviar'}
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      setShowWhatsappInput(false);
                      if (whatsappPhoneRef.current) {
                        whatsappPhoneRef.current.value = '';
                      }
                    }}
                    style={{
                      padding: '8px',
                      borderRadius: '8px',
                      border: 'none',
                      backgroundColor: '#be3026',
                      color: '#fff',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <BiX size={18} style={{ margin: 0 }}/>
                  </button>
                </div>
              ) : (
                <p onClick={() => setShowWhatsappInput(true)}>
                  <FaWhatsapp /> <span>WhatsApp</span>
                </p>
              )}
            </div>
          </div>
          <div className="form">
            <Select
              id="searchGroups"
              name="searchGroups"
              placeholder="Selecione uma opção"
              defaultValue={searchGroupsOptions.find(
                (searchGroup) => searchGroup.value === groupToSearch,
              )}
              options={searchGroupsOptions}
              onChange={({ value }: SelectOptionType) =>
                setGroupToSearch(value)
              }
              maxMenuHeight={140}
            />
            <Input
              ref={searchProductsRef}
              icon={BiSearch}
              placeholder="Buscar nas categorias"
            />
          </div>
        </PageHeaderActions>
        <Accordions ref={groupListDiv}>
          {handleFilterGroups().map((group) => {
            if (group.type === 1) {
              return (
                <SimpleGroupAccordion
                  key={group.id}
                  groupId={group.id}
                  groupName={group.name}
                  products={group.products}
                  onEdit={() => handleEditSimpleGroup(group.id)}
                  onDelete={() => handleDeleteGroup(group.id)}
                  onCreateProduct={() => handleCreateSimpleProduct(group.id)}
                  onEditProduct={(productId) =>
                    handleEditSimpleProduct(productId, group.id)
                  }
                  onCloneProduct={(productId) =>
                    handleCloneSimpleProduct(productId, group.id)
                  }
                  onDeleteProduct={(productId) =>
                    handleDeleteProduct(productId, group.id)
                  }
                  onChangeProductPauseSale={(productId, status) =>
                    handleChangeProductStatus(group.id, productId, status)
                  }
                  onSortProducts={(products) =>
                    handleSortProducts(group.id, products)
                  }
                  pauseSale={!!group.pauseSale}
                  onChangePauseSale={() =>
                    handleChangeGroupStatus(group.id, !group.pauseSale)
                  }
                  onEditProductImage={(productId, productImage) =>
                    handleAttemptToEditProductImage(
                      productId,
                      group.id,
                      productImage,
                    )
                  }
                />
              );
            }

            if (group.type === 2) {
              return (
                <GridGroupAccordion
                  key={group.id}
                  groupId={group.id}
                  groupName={group.name}
                  onEdit={() => handleEditGridGroup(group.id)}
                  onDelete={() => handleDeleteGroup(group.id)}
                  onCreateProduct={() => handleCreateGridProduct(group.id)}
                  onSortProducts={(products) =>
                    handleSortProducts(group.id, products)
                  }
                  pauseSale={!!group.pauseSale}
                  onChangePauseSale={() =>
                    handleChangeGroupStatus(group.id, !group.pauseSale)
                  }
                  products={group.products}
                  onChangeProductPauseSale={(productId, status) =>
                    handleChangeProductStatus(group.id, productId, status)
                  }
                  onDeleteProduct={(productId) =>
                    handleDeleteProduct(productId, group.id)
                  }
                  onCloneProduct={(productId) =>
                    handleCloneGridProduct(productId, group.id)
                  }
                  onEditProduct={(productId) =>
                    handleEditGridProduct(productId, group.id)
                  }
                  onEditProductImage={(productId, productImage) =>
                    handleAttemptToEditProductImage(
                      productId,
                      group.id,
                      productImage,
                    )
                  }
                />
              );
            }

            if (group.type === 3) {
              return (
                <PizzaGroupAccordion
                  key={group.id}
                  groupId={group.id}
                  groupName={group.name}
                  onEdit={() => handleEditPizzaGroup(group.id)}
                  onDelete={() => handleDeleteGroup(group.id)}
                  onCreateProduct={() => handleCreatePizzaProduct(group.id)}
                  onSortProducts={(products) =>
                    handleSortProducts(group.id, products)
                  }
                  pauseSale={!!group.pauseSale}
                  onChangePauseSale={() =>
                    handleChangeGroupStatus(group.id, !group.pauseSale)
                  }
                  products={group.products}
                  onChangeProductPauseSale={(productId, status) =>
                    handleChangeProductStatus(group.id, productId, status)
                  }
                  onDeleteProduct={(productId) =>
                    handleDeleteProduct(productId, group.id)
                  }
                  onEditProduct={(productId) =>
                    handleEditPizzaProduct(productId, group.id)
                  }
                  onCloneProduct={(productId) =>
                    handleClonePizzaProduct(productId, group.id)
                  }
                  onEditProductImage={(productId, productImage) =>
                    handleAttemptToEditProductImage(
                      productId,
                      group.id,
                      productImage,
                    )
                  }
                />
              );
            }

            return null;
          })}
        </Accordions>
      </Wrapper>
      <Modal ref={selectGroupModalRef}>
        <ModalHeader>
          <h1>Novo grupo</h1>
          <h3>Selecione o tipo do grupo para organizar seus produtos</h3>
          <CloseModalButton
            onClick={() => selectGroupModalRef.current?.close()}
          >
            <BiX />
          </CloseModalButton>
        </ModalHeader>
        <GroupTypeItems>
          <GroupTypeItem onClick={() => handleSelectGroupType(1)}>
            <BiBox />
            <h3>Simples</h3>
            <p>Alimentação, matérias primas, varejo em geral, etc</p>
          </GroupTypeItem>
          <GroupTypeItem onClick={() => handleSelectGroupType(2)}>
            <BiGridAlt />
            <h3>Grade</h3>
            <p>Defina os tamanhos e as cores</p>
          </GroupTypeItem>
          <GroupTypeItem onClick={() => handleSelectGroupType(3)}>
            <BiRestaurant />
            <h3>Pizza</h3>
            <p>Defina os tamanhos e os complementos</p>
          </GroupTypeItem>
        </GroupTypeItems>
      </Modal>
      <Modal ref={sortModalRef} animated={false}>
        <ModalHeader style={{ textAlign: 'start' }}>
          <h2>Reordenar</h2>
          <p>
            Para alterar a ordem dos grupos ou dos produtos, clique na opção
            desejada, segure e arraste.
          </p>
          <CloseModalButton
            onClick={handleCancelSortModal}
            disabled={isLoadingSort}
          >
            <BiX />
          </CloseModalButton>
        </ModalHeader>
        <SortableContainer>
          <SortableHeader column={modalReordenIsOpen}>
            <div className="grupos">
              <h2>Grupos</h2>
            </div>
            <div className="produtos">
              <div
                className="icon"
                onClick={() => {
                  setActiveGroup(undefined);
                  setProductsToSort([]);
                  if (complementsToSort.length > 0) {
                    setComplementsToSort([]);
                  }
                  if (complementItemsToSort.length > 0) {
                    setComplementItemsToSort([]);
                  }
                }}
              >
                <IoMdArrowBack />
              </div>
              <h2>Produtos</h2>
            </div>
            <div className="complementos">
              <div
                className="icon"
                onClick={() => {
                  setActiveProduct(undefined);
                  setComplementsToSort([]);

                  if (complementItemsToSort.length > 0) {
                    setComplementItemsToSort([]);
                  }
                }}
              >
                <IoMdArrowBack />
              </div>
              <h2>Complementos</h2>
            </div>
            <div className="itens">
              <div
                className="icon"
                onClick={() => {
                  setActiveComplement(undefined);
                  setComplementItemsToSort([]);
                }}
              >
                <IoMdArrowBack />
              </div>
              <h2>Itens</h2>
            </div>
          </SortableHeader>
          <SortableContent column={modalReordenIsOpen}>
            <SortableColumn id="grupos">
              <DragDropContext
                onDragEnd={(dropResult) => handleOnGroupsDragEnd(dropResult)}
              >
                <Droppable droppableId="droppableSortGroups">
                  {(droppableProvided) => (
                    <div
                      ref={droppableProvided.innerRef}
                      {...droppableProvided.droppableProps}
                    >
                      {groupsToSort.map((group, groupIndex) => (
                        <Draggable
                          key={String(`group-${group.id}`)}
                          draggableId={String(`group-${group.id}`)}
                          index={groupIndex}
                          isDragDisabled={isLoadingSort}
                        >
                          {(draggableProvided) => (
                            <div
                              ref={draggableProvided.innerRef}
                              {...draggableProvided.draggableProps}
                              {...draggableProvided.dragHandleProps}
                              style={{
                                ...draggableProvided.draggableProps.style,
                              }}
                            >
                              <SortableItem
                                active={group.id === activeGroup}
                                onClick={() => handleActiveGroup(group.id)}
                              >
                                <BiMenu />
                                <p>{group.name}</p>
                                <AiOutlineDoubleRight className="right_arrow" />
                              </SortableItem>
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {droppableProvided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </SortableColumn>
            <SortableColumn id="produtos">
              <DragDropContext
                onDragEnd={(dropResult) => handleOnProductsDragEnd(dropResult)}
              >
                <Droppable droppableId="droppableSortGroups">
                  {(droppableProvided) => (
                    <div
                      ref={droppableProvided.innerRef}
                      {...droppableProvided.droppableProps}
                    >
                      {productsToSort.map((product, productIndex) => (
                        <Draggable
                          key={String(`product-${product.id}`)}
                          draggableId={String(`product-${product.id}`)}
                          index={productIndex}
                          isDragDisabled={isLoadingSort}
                        >
                          {(draggableProvided) => (
                            <div
                              ref={draggableProvided.innerRef}
                              {...draggableProvided.draggableProps}
                              {...draggableProvided.dragHandleProps}
                              style={{
                                ...draggableProvided.draggableProps.style,
                              }}
                            >
                              <SortableItem
                                active={product.id === activeProduct}
                                onClick={() => handleActiveProduct(product.id)}
                              >
                                <BiMenu />
                                <p>{product.name}</p>
                                <AiOutlineDoubleRight className="right_arrow" />
                              </SortableItem>
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {droppableProvided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </SortableColumn>
            <SortableColumn id="complementos">
              <DragDropContext
                onDragEnd={(dropResult) =>
                  handleOnComplementsDragEnd(dropResult)
                }
              >
                <Droppable droppableId="droppableSortGroups">
                  {(droppableProvided) => (
                    <div
                      ref={droppableProvided.innerRef}
                      {...droppableProvided.droppableProps}
                    >
                      {complementsToSort.map((complement, complementIndex) => (
                        <Draggable
                          key={String(`complement-${complement.id}`)}
                          draggableId={String(`complement-${complement.id}`)}
                          index={complementIndex}
                          isDragDisabled={isLoadingSort}
                        >
                          {(draggableProvided) => (
                            <div
                              ref={draggableProvided.innerRef}
                              {...draggableProvided.draggableProps}
                              {...draggableProvided.dragHandleProps}
                              style={{
                                ...draggableProvided.draggableProps.style,
                              }}
                            >
                              <SortableItem
                                active={complement.id === activeComplement}
                                onClick={() =>
                                  handleActiveComplement(complement.id)
                                }
                              >
                                <BiMenu />
                                <p>{complement.name}</p>
                                <AiOutlineDoubleRight className="right_arrow" />
                              </SortableItem>
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {droppableProvided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </SortableColumn>
            <SortableColumn id="itens">
              <DragDropContext
                onDragEnd={(dropResult) =>
                  handleOnComplementItemsDragEnd(dropResult)
                }
              >
                <Droppable droppableId="droppableSortGroups">
                  {(droppableProvided) => (
                    <div
                      ref={droppableProvided.innerRef}
                      {...droppableProvided.droppableProps}
                    >
                      {complementItemsToSort.map(
                        (complementItem, complementItemIndex) => (
                          <Draggable
                            key={String(`complementItem-${complementItem.id}`)}
                            draggableId={String(
                              `complementItem-${complementItem.id}`,
                            )}
                            index={complementItemIndex}
                            isDragDisabled={isLoadingSort}
                          >
                            {(draggableProvided) => (
                              <div
                                ref={draggableProvided.innerRef}
                                {...draggableProvided.draggableProps}
                                {...draggableProvided.dragHandleProps}
                                style={{
                                  ...draggableProvided.draggableProps.style,
                                }}
                              >
                                <SortableItem active={false}>
                                  <BiMenu />
                                  <p>{complementItem.name}</p>
                                </SortableItem>
                              </div>
                            )}
                          </Draggable>
                        ),
                      )}
                      {droppableProvided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </SortableColumn>
          </SortableContent>
        </SortableContainer>
        <ModalFooter>
          <Button
            variant="outlined"
            onClick={handleCancelSortModal}
            disabled={isLoadingSort}
          >
            Cancelar
          </Button>
          <Button onClick={handleOnSortEnd} loading={isLoadingSort}>
            Salvar
          </Button>
        </ModalFooter>
      </Modal>
      <SimpleGroupDrawer
        onSuccessSave={handleOnGroupSuccessSave}
        lastGroupIndex={handleLastGroupIndex()}
      />
      <PizzaGroupDrawer
        onSuccessSave={handleOnGroupSuccessSave}
        lastGroupIndex={handleLastGroupIndex()}
      />
      <GridGroupDrawer
        onSuccessSave={handleOnGroupSuccessSave}
        lastGroupIndex={handleLastGroupIndex()}
      />
      <SimpleProductDrawer
        onSuccessSave={handleOnProductSuccessSave}
        lastProductIndex={handleLastProductIndex()}
      />
      <PizzaProductDrawer
        onSuccessSave={handleOnProductSuccessSave}
        lastProductIndex={handleLastProductIndex()}
      />
      <GridProductDrawer
        onSuccessSave={handleOnProductSuccessSave}
        lastProductIndex={handleLastProductIndex()}
      />
      <Modal ref={updateImageModalRef}>
        <ModalHeader>
          <h1>Atualizar imagem</h1>
          <CloseModalButton onClick={handleCancelProductImageEditing}>
            <BiX />
          </CloseModalButton>
        </ModalHeader>
        <FileInput
          id="updateProductImageFileInput"
          icon={BiImage}
          title="Escolha uma imagem"
          selectedImage={updateProductImage?.image}
          acceptableTypes=".jpeg,.jpg,.png"
          subtitle="Formatos: .jpeg, .jpg, .png"
          containerStyle={{
            width: 'auto',
            maxWidth: 300,
            marginTop: 20,
            marginBottom: 20,
          }}
          onRemove={() =>
            setUpdateProductImage((oldState) => ({
              ...oldState,
              image: undefined,
            }))
          }
          onSelectFile={(file) =>
            setUpdateProductImage((oldState) => ({ ...oldState, image: file }))
          }
        />
        <Button
          full
          onClick={handleEditProductImage}
          style={{ marginBottom: 10 }}
          loading={isLoadingUpdateProductImage}
        >
          Salvar
        </Button>
        <Button
          full
          variant="outlined"
          onClick={handleCancelProductImageEditing}
        >
          Cancelar
        </Button>
      </Modal>
    </Container>
  );
};

export default Products;
